import React, { ReactElement } from 'react';

const SvgCartHeader = (props: React.SVGProps<SVGSVGElement>): ReactElement => (
    <svg viewBox="0 0 30 30" height="30" width="30" fill="currentColor" {...props}>
        <path
            d="M15 7a3 3 0 0 1 2.995 2.824L18 10h5v13H7V10h5a3 3 0 0 1 3-3zm7.111 3.893H7.89V22.12H22.11V10.893zM15 7.891c-1.53 0-2.107 1.28-2.107 2.109h4.223c0-.828-.586-2.11-2.116-2.11z"
            fillRule="evenodd"
        />
    </svg>
);

export default SvgCartHeader;
